import config from "config"

export interface ITrafficTypes {
  INBOUND: string
  OUTBOUND: string
}

export const Q_TRAFFIC_TYPE: string = "traffic-type"

export const DEFAULT_TRAFFIC_TYPE: string = "inbound"

export const BUS_PAGE_MOBILE_URL: string = `${config(
  "mobileBaseUrl"
)}/transportation/bus`

export const TAXI_PAGE_MOBILE_URL: string = `${config(
  "mobileBaseUrl"
)}/transportation/taxi`

export const BTS_PAGE_MOBILE_URL: string = `${config(
  "mobileBaseUrl"
)}/transportation/bts`

export const trafficTypes: ITrafficTypes = {
  INBOUND: "inbound",
  OUTBOUND: "outbound",
}
